export const AI_SYSTEM_TAB_COUNT = 7;

export const AI_SYSTEM_TAB_FIELDS = [
  [
    "name",
    "providerId",
    "systemType",
    "otherSystemType",
    "useCase",
    "aiUseTypes",
    "otherAiUseType",
    "ownerName",
    "valueChainRoles",
    "businessAreas",
    "otherBusinessArea",
    "clientId",
    "lifecycleStage",
  ],
  [
    "trainingDataProvenance",
    "trainingDataNoRationale",
    "otherTrainingDataCategory",
  ],
  [
    "operationalDataTypes",
    "thirdPartyClientDataDetails",
    "operationalDataNoRationale",
  ],
  [
    "toolingNoRationale",
    "otherProvisioning",
    "otherInfrastructureProvider",
  ],
  ["computingNoRationale"],
  [
    "humanOversightDetails",
    "humanResourcesNoRationale",
    "operationalRoles",
    "governanceComplianceRoles",
    "trainingCompetenceRequirements",
    "otherIncidentNotifyRole",
    "otherOperationalRole",
    "otherTechnicalDevelopmentRole",
    "otherGovernanceComplianceRole",
  ],
  [
    "riskAssessmentRef",
    "approvedByName",
    "approvalDate",
    "reviewDate",
    "conditionsRestrictions",
  ],
];

export function firstTabWithErrors(errors = {}) {
  const index = AI_SYSTEM_TAB_FIELDS.findIndex((fields) =>
    fields.some((field) => errors[field]),
  );
  return index === -1 ? 0 : index;
}
